import { type DynamicForms } from "@common/controls/Form/DynamicForm/types";
import { System } from "@common/declarations";

const mapFieldToDynamicFieldBase = (x: System.Api.FormField): DynamicForms.Field => ({
  componentProps: x.componentProps,
  dataType: x.dataType,
  description: x.description,
  formControlKey: x.formControlKey,
  label: x.label ?? x.name,
  name: x.formFieldId,
  options: x.options,
  source: x.source,
  validations: x.validations,
  value: x.plainTextValue ?? x.value,
  visibilityCondition: x.visibilityCondition,
  valuePlain: x.plainTextName ?? x.plainTextLabel,
  fetchDefaultOption: x.fetchDefaultOption,
  group: x.group
});

type GetName<T> = (field: T) => string;

export const mapFormFieldsToDynamicFields = (fields: System.FormField[]): DynamicForms.Field[] =>
  fields.map(mapFormFieldToDynamicField);

export const mapFormFieldToDynamicField = (field: System.Api.FormField): DynamicForms.Field =>
  mapFieldToDynamicFieldBase(field);

export const mapFormFieldsWithContextToDynamicFields = <T extends System.Api.FormFieldWithContext>(
  fields: T[],
  getName?: GetName<T>
): DynamicForms.Field[] => fields.map((x) => mapFormFieldWithContextToDynamicField(x, getName));

export const mapFormFieldWithContextToDynamicField = <T extends System.Api.FormFieldWithContext>(
  field: T,
  getName?: GetName<T>
): DynamicForms.Field => {
  const mapped = mapFieldToDynamicFieldBase(field);
  return {
    ...mapped,
    label: field.caption ?? mapped.label,
    isRequired: field.isRequired,
    name: getName ? getName(field) : mapped.name,
    sortOrder: field.sortOrder,
    width: field.width
  };
};
